import { boot } from 'quasar/wrappers'
import '@fortawesome/fontawesome-pro/css/fontawesome.css'
import '@fortawesome/fontawesome-pro/css/light.css'
import '@fortawesome/fontawesome-pro/css/brands.css'
import '@fortawesome/fontawesome-pro/css/solid.css'
import '@fortawesome/fontawesome-pro/css/regular.css'

export default boot(({ app }) => {
	app.config.globalProperties.$q.iconSet.chip.remove = 'fas fa-times-circle'
})
